export default __webpack_public_path__ + "static/media/warning.0d3b46ed.svg";